
import { useTranslation } from 'react-i18next'

import { Drawer } from '@mercai/clever'

import { formatDateWithTime } from '@/helpers'

import {
  useHostConversationDetail,
} from '@/services'

import { Chat, Header } from './components'

import type { IAHostMessageProps } from '@/types'
import type { DrawerChatProps } from './drawer-chat.type'

import styles from './drawer-chat.module.css'

export const ConversationDrawerChat = ({
  uuid,
  isOpen,
  onClose,
}: DrawerChatProps) => {
  const { t } = useTranslation('screenLeadIntake')


  const { data: conversationDetail, isLoading: isLoadingConversationDetail } =
    useHostConversationDetail(uuid, {
      refetchInterval: isOpen ? 3000 : undefined,
    })


  return (
    <Drawer isOpen={isOpen || false} onHandleOpen={() => onClose?.()}>
      <div className={styles.core}>
        <Header
          title={`${t('drawerChatHeaderTitle')} ${formatDateWithTime(
            conversationDetail?.data?.createdAt || new Date(),
          )}`}
          description={`${t('drawerChatHeaderDescription')} ${conversationDetail?.data?.remoteNumber || ''}`}
        />

        <Chat
          messages={conversationDetail?.data?.messages as IAHostMessageProps[]}
          isLoading={isLoadingConversationDetail}
        />
      </div>
    </Drawer>
  )
}
